var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m309.673 657.944 28.284-28.284 59.396 59.396-28.284 28.284z",
    fill: "#6ee7b7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m311.115 604.195 153.44-153.44 127.278 127.277-153.44 153.44z",
    fill: "#6ee7b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m365.328 664.026 5.656-5.657 36.628 36.628-5.657 5.657zm-55.577-55.599 5.657-5.657 36.628 36.628-5.657 5.657zM447.478 507.89l5.657-5.656 65.124 65.123-5.657 5.657zM407.79 548.304l5.657-5.656 65.123 65.124-5.656 5.656zM367.72 588.349l5.656-5.657 65.124 65.124-5.657 5.657zm-60.033 73.675 5.657-5.657 54.941 54.942-5.657 5.657z",
    fill: "#064e3b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m834.9 321.4-12.2-12.2-27.3-27.3 41-41 45.2 45.2 10.6-10.6-45.2-45.2-54-54-43.2-43.2-10.6 10.6 43.2 43.2-41 41-111.7-111.8-10.6 10.6 59.1 59.1c-1.1.7-2.2 1.6-3.1 2.5l-384 384c-3.6 3.6-5.6 8.4-5.6 13.4s2 9.9 5.6 13.4l33.4 33.4-15.7 15.7c-3.3 3.3-5.3 7.7-5.5 12.3l-55.8 91.6 7.2 7.2-65.4 65.4 10.6 10.6 65.4-65.4 6.6 6.6 92-56.7c4.2-.5 8.1-2.4 11.1-5.4l15.7-15.7 33.4 33.4c3.6 3.6 8.4 5.6 13.4 5.6 5.1 0 9.9-2 13.4-5.6l384-384c1-1 1.8-2 2.5-3.1l61.2 61.2 10.6-10.6-74.3-74.2zM793 197.5l32.8 32.8-41 41-32.8-32.8 41-41zm31.3 140.2-384 384c-1 1-2.2 1.2-2.8 1.2-.6 0-1.8-.2-2.8-1.2l-44-44-26.3 26.3c-1 1-2.2 1.2-2.8 1.2h-2.1l-83.9 51.7-8.3-8.3 51.2-84-.2-2.4c-.1-1.2.3-2.4 1.1-3.2l26.3-26.3-44-44c-1-1-1.2-2.2-1.2-2.8s.2-1.8 1.2-2.8l384-384c1.5-1.5 4.1-1.5 5.7 0l133 133c1.4 1.4 1.4 4-.1 5.6z",
    fill: "#064e3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m548.5 520.5-45-45 240-240 45 45-240 240zm-33.7-45 33.7 33.7 228.7-228.7-33.7-33.7-228.7 228.7z",
    fill: "#064e3b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M584.7 577.3 446.2 438.7l15.6-15.6 138.6 138.6-15.7 15.6zM457.5 438.7 584.7 566l4.2-4.2-127.2-127.3-4.2 4.2z",
    fill: "#064e3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInject);
export default __webpack_public_path__ + "static/media/Inject.a5e56daa028949d05f1f7f1f259820b2.svg";
export { ForwardRef as ReactComponent };